var _            = require('underscore');
var $            = require('jquery');
var Core         = require('../core/core.js');
var Theme        = require('../theme/theme.js');
var EditorHolder = require('../editorHolder/editorHolder.js');
var Switcher  = require('../switcher/switcher.js');

/**
 * Creates a SplitItem
 *
 * @class
 */

class SplitItem extends Core {

    _defaults() {
        return {
            target: '.js-splititem',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        this.template = `<div class='editor__split__item'></div>`;

        super.render();
    }

    /**
     * Add an Editor Holder to the tab
     */
    addEditorHolderTemplate(){
        return new EditorHolder({
            target: this.$el
        });
    }


    /**
     * Set the theme of specific side
     */
    setTheme(theme){
        Theme(theme, this.$el);
    }

    /**
     * Adds a footprint switcher
     */
    addSwitcher(canNotEdit){
        return new Switcher({
            target: this.$el,
            fields: {
                'canNotEdit': canNotEdit
            }
        });
    }

}
module.exports = SplitItem;